import { AccountMap } from '../../../models/AccountMap';
import { Acc_Txn_Service } from '../../../services/Acc_Txn_Servcies';
import { GL_MasterService } from '../../../services/Acc_GL_Master.service';
import { UtilityService } from '../../../services/Acc_Utility.service';
import { AccountMappingService } from '../../../services/AccountMappingService';
import { Global } from '../../global';
import { GL_Child } from '../../../models/GL_Child';
import { JournalEntry } from '../../../models/Txn_JournalEntry';
import { Component, OnInit } from '@angular/core';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import {FormControl,FormGroup, Validators} from '@angular/forms';
import {MatSnackBar} from '@angular/material';
import * as moment from 'jalali-moment';
import { DatePipe } from '@angular/common';
import * as $ from 'jquery';
import { InvoiceService } from '../../../services/Acc_InvoiceService';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { concat } from 'rxjs/observable/concat';
import { Txn_Invoice } from '../../../models/Txn_Invoice';
import { DariCalendarService } from '../../../services/DariCalendar';

@Component({
  selector: 'app-student-recieve-inv',
  templateUrl: './student-recieve-inv.component.html',
  styleUrls: ['./student-recieve-inv.component.css']
})
export class StudentRecieveInvComponent implements OnInit {

  ArrLabels: any;
  labels: any = {};
  invoiceList: any = {};
  isPrintable: boolean;
  StudentAccounts: any;
  pendingInvoices: any;
  inv_number: number;

  txns: JournalEntry[];
  txn_Invoice: Txn_Invoice = {
    inv_no: 0,
    inv_amount: 0,
    relatedAccount: "",
    discount_amount: 0,
    payable_amount: 0,
    makerID: "test",
    checkerID: "test",
    clearDate: null,
    clear_status: "N",
    authStat: "A",
    clearBankRefNO: "",
    issueDate: new Date(),
    expiryDate: new Date(),
    semester: null,
    trn_ref_clear: "",
    trn_ref_issue: "",
    issue_remark: "",
    invoiceType: "",
    invoiceDesc: "",
    year: "",
    season: "",
    installmentNumber: 0,
    installmentNumbers: '',
    isRepeatSemester: false,
    userId: '',
    branchId: '',
    discountValue: 0,
    repeatSemesterSerie: 1,
    termId:0,
  }
  // response objects
  txn_result: any;
  arr_results: any = {};

  ArrAccountMaps: any;
  MasterAccCR:any; 
  MasterAccDR:any;
  DebitAccounts: any;
  studentDetails: any = {};
  selectedAccountName: any;
  prntselectedAccountName: any;
  studentName: any = {};

  prntSelectedBankAccount: string;
  prntSelectedBankNumber: string;
  pdate = moment(new Date()).format('jYYYY-jMM-jDD');    // Dari date
  printVariables: any = {};

  // Bank account leg
  txn_DR: JournalEntry = {
    module: "FT",
    trn_ref_no: "",
    event_sr_no:1,
    eventName:"INIT",
    ac_entry_sr_no: 0,
    ac_branch: "000",
    GL_Code :"",
    drcr_ind: "DR",
    trn_code:"AAT",
    trn_amount: null,
    trn_date:new Date(),
    value_date: new Date(),
    financial_cycle:"",
    period_code:"",
    batch_no:"1111",
    MakerID:"test",
    CheckerID :"test",
    auth_stat:"A",
    delete_stat:"",
    product:"REIN",
    external_ref_no :"",
    entry_seq_no : 0,
    remarks: "",
    userId: "",
    documentNo: "",
    branchId: 0,
    statusId: 0,
    isPrint: false,
    branchTitle: '',
    statusTitle: '',
    }

    //student account leg
    txn_CR: JournalEntry = {
      module: "FT",
      trn_ref_no: "",
      event_sr_no:2,
      eventName:"INIT",
      ac_entry_sr_no: 0,
      ac_branch: "000",
      GL_Code :"",
      drcr_ind: "CR",
      trn_code:"AAT",
      trn_amount: null,
      trn_date:new Date(),
      value_date: new Date(),
      financial_cycle:"",
      period_code:"",
      batch_no:"",
      MakerID:"",
      CheckerID :"",
      auth_stat:"",
      delete_stat:"",
      product:"REIN",
      external_ref_no :"",
      entry_seq_no : 0,
      remarks: "",
      userId: '',
      documentNo: "",
      branchId: 0,
      statusId: 0,
      isPrint: false,
      branchTitle: '',
      statusTitle: '',
      }

  // temp account receivable leg
  txn_DR_Rec: JournalEntry = {
    module: "FT",
    trn_ref_no: "",
    event_sr_no:1,
    eventName:"INIT",
    ac_entry_sr_no: 0,
    ac_branch: "000",
    GL_Code :"", //A10002
    drcr_ind: "DR",
    trn_code:"AAT",
    trn_amount: null,
    trn_date:new Date(),
    value_date: new Date(),
    financial_cycle:"",
    period_code:"",
    batch_no:"1111",
    MakerID:"test",
    CheckerID :"test",
    auth_stat:"A",
    delete_stat:"",
    product:"REIN",
    external_ref_no :"",
    entry_seq_no : 0,
    remarks: "",
    userId: '',
    documentNo: "",
    branchId: 0,
    statusId: 0,
    isPrint: false,
    branchTitle: '',
    statusTitle: '',
    }

    //Income leg
    txn_CR_Inc: JournalEntry = {
      module: "FT",
      trn_ref_no: "",
      event_sr_no:2,
      eventName:"INIT",
      ac_entry_sr_no: 0,
      ac_branch: "000",
      GL_Code :"", //N10001
      drcr_ind: "CR",
      trn_code:"AAT",
      trn_amount: null,
      trn_date:new Date(),
      value_date: new Date(),
      financial_cycle:"",
      period_code:"",
      batch_no:"",
      MakerID:"",
      CheckerID :"",
      auth_stat:"",
      delete_stat:"",
      product:"REIN",
      external_ref_no :"",
      entry_seq_no : 0,
      remarks: "",
      userId: '',
      documentNo: "",
      branchId: 0,
      statusId: 0,
      isPrint: false,
      branchTitle: '',
      statusTitle: '',
      }


      filteredOptions: Observable<string[]>;
      myControl = new FormControl();

  constructor(
    private GL_MasterService: GL_MasterService,
    private global:Global,
    private UtilityService: UtilityService,
    private Txn_DE_Service: Acc_Txn_Service,
    public snackBar: MatSnackBar,
    public datepipe: DatePipe,
    private DariCalendar: DariCalendarService,
    private AccountMapService: AccountMappingService,
    private InvoiceService: InvoiceService
  ) { }

  ngOnInit() {
    console.log(this.txn_DR.trn_date.toString());
    this.getLabels();
    this.getAccountMaps();
    this.getBranchId();
      // make delay to load the credit/debit accounts...
      setTimeout(() => { this.getDebitAccounts(); }, 1000 );

      // make dealy...
    
    setTimeout(() => {
      console.log(`student accounts: ${this.StudentAccounts}`);
      this.filteredOptions = this.myControl.valueChanges
        .pipe(
          startWith(''),
          map(value => this._filter(value))
        )}, 2000 );
    console.log("account control --> " + this.myControl.valueChanges);
  }

  isBranchId: number = -1;
  userId: string = "";
  getBranchId() {
     
    let data = localStorage.getItem('accessKeyUser');
    let dataAccess = JSON.parse(data);
    let dataAccessUrl = dataAccess.filter(f => f.accessKeyUrl == "/discount")[0];
    if (dataAccessUrl != undefined) {
      if (dataAccessUrl.isMainBranch)
        this.isBranchId = 1;
      else if (dataAccessUrl.isWestBranch)
        this.isBranchId = 2;
      else
        this.isBranchId = 0;
      this.userId = dataAccessUrl.userId;
    }
  }


  searchStudent() {
     
    let a = $('input[id="studentAccountID"]').val();
    this.GL_MasterService.getStudentName(a).subscribe(
      result => {
        if (result) {
          this.studentName = result.json();
          console.log(this.studentName);
          this.GL_MasterService.getStudentDetails(a , 0).subscribe(
            result => {
              if (result) {
                this.studentDetails = result.json();
                console.log(this.studentDetails);
              }
            }
          );
          this.AccountChanged(this.studentName["gL_ChildCode"], this.studentName["gL_ChildDesc"]);
        } else {
          this.openSnackBar(null, 'محصل یافت نشد');
        }
      }
    );
  }
  AccountChanged(gL_ChildCode, gL_ChildDesc) {
    console.log(":____>  " + gL_ChildDesc);
    //console.log(this.StudentAccounts);
    this.selectedAccountName = gL_ChildDesc;
    this.prntselectedAccountName = gL_ChildDesc;
    this.getPendingInvoices(gL_ChildCode);
  }
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    console.log(`value: ${value}`);
    return this.StudentAccounts.filter(option => option.gL_ChildCode.toLowerCase().includes(filterValue));
    
  }

  getPendingInvoices(gL_ChildCode: string)
  {
    this.InvoiceService.getpendingInvoices(gL_ChildCode)
    
      .subscribe(response => {
        if (response) {
            this.pendingInvoices = response;
            console.log(response);
        }
    },
    error => console.log("error --> " + error))
  }
  inv_change()
  {
    var amount = this.pendingInvoices.find( (o:any) => o.inv_no.toString() === this.inv_number.toString()).inv_amount;
    this.printVariables['trn_discount'] = this.pendingInvoices.find( (o:any) => o.inv_no.toString() === this.inv_number.toString()).discount_amount;
    this.printVariables['payable_amount'] = this.pendingInvoices.find( (o:any) => o.inv_no.toString() === this.inv_number.toString()).payable_amount;
    this.printVariables['inv_no'] = this.pendingInvoices.find( (o:any) => o.inv_no.toString() === this.inv_number.toString()).inv_no;
    
    console.log(this.selectedAccountName);
    this.txn_DR.trn_amount = amount;
    //this.txn_DR.external_ref_no = this.inv_number.toString();
  }
  getInvoice(inv_no: string) {
    this.InvoiceService.getInvoiceR(inv_no)
      .subscribe(response => {
        this.invoiceList = response;
        console.log(`list of invoices: ` + response);
        for (let inv in this.invoiceList) {
          console.log(`invoice type Desc: ` + this.invoiceList[inv].invoiceDesc);
          console.log(`invoice type: ` + this.invoiceList[inv].invoiceType);
          // replace date with dari farmat.
          if (this.invoiceList[inv].issueDate)
            this.invoiceList[inv].issueDate_da = this.DariCalendar.PersianCalendar(new Date(this.invoiceList[inv].issueDate));
          if (this.invoiceList[inv].clearDate)
            this.invoiceList[inv].clearDate_da = this.DariCalendar.PersianCalendar(new Date(this.invoiceList[inv].clearDate));
          if (this.invoiceList[inv].expiryDate)
            this.invoiceList[inv].expiryDate_da = this.DariCalendar.PersianCalendar(new Date(this.invoiceList[inv].expiryDate));
          this.printVariables['inv_no'] = this.invoiceList[inv].inv_no;
          this.printVariables['trn_amount'] = this.invoiceList[inv].inv_amount;
          this.printVariables['trn_date'] = this.invoiceList[inv].issueDate_da;
          this.printVariables['trn_desc'] = this.invoiceList[inv].issue_remark;
          this.printVariables['trn_discount'] = this.invoiceList[inv].discount_amount;
          this.printVariables['payable_amount'] = this.invoiceList[inv].payable_amount;
          this.printVariables['student_account'] = this.invoiceList[inv].relatedAccount;
          this.printVariables['gL_ChildDesc'] = this.invoiceList[inv].gL_ChildDesc;
          this.printVariables['name'] = this.invoiceList[inv].gL_ChildDesc.split("ولد")[inv];
          this.printVariables['fname'] = this.invoiceList[inv].gL_ChildDesc.split("ولد")[1];
          this.printVariables['trn_ref_no'] = this.invoiceList[inv].trn_ref_issue;
          this.printVariables['CheckerID'] = this.invoiceList[inv].CheckerID;
          this.printVariables['expDate'] = this.invoiceList[inv].expiryDate_da;
          this.printVariables['semester'] = this.invoiceList[inv].semester;
          this.printVariables['udF2'] = this.invoiceList[inv].udF2;
          this.printVariables['udF3'] = this.invoiceList[inv].udF3;
          this.printVariables['months'] = this.invoiceList[inv].installmentNumber; // -------------------
          this.printVariables['department'] = this.invoiceList[inv].department;
          this.printVariables['invoiceDesc'] = this.invoiceList[inv].invoiceDesc;
          this.isPrintable = this.invoiceList[inv].invoiceDesc == 'هزینه چانس' ||
            this.invoiceList[inv].invoiceDesc == 'هزینه داخله' ||
            this.invoiceList[inv].invoiceDesc == 'فیس سمستر';
          this.printVariables['bankAccountNameFa'] = this.invoiceList[inv].bankAccountNameFa;
          this.printVariables['bankAccountNumber'] = this.invoiceList[inv].bankAccountNumber;

          this.printVariables['trn_discountValue'] = this.invoiceList[inv].discountValue;

          let InstallmentNumbers = this.invoiceList[inv].installmentNumbers.split(',');
          let currentMounth = 0;
          let currentMonthTitle = '';
          for (var i = 0; i < InstallmentNumbers.length; i++) {
            currentMounth = parseInt(InstallmentNumbers[i]);
            if (currentMounth == 1)
              currentMonthTitle = "اول";
            if (currentMounth == 2)
              currentMonthTitle += "," + "دوم";
            if (currentMounth == 3)
              currentMonthTitle += "," + "سوم";
            if (currentMounth == 4)
              currentMonthTitle += "," + "چهارم";
            if (currentMounth == 5)
              currentMonthTitle += "," + "پنجم";
            if (currentMounth == 6)
              currentMonthTitle += "," + "ششم";
          }
          this.printVariables['installmentMonthTitle'] = currentMonthTitle;
          
        }
      });
  }
  getDebitAccounts()
  {
    this.GL_MasterService.getGL_Childs(this.MasterAccDR, this.isBranchId)
      .subscribe(response => {
        if (response) {
            this.DebitAccounts = response;
        }
    },
    error => console.log("error --> " + error))
  } 

 
  getGlChilds()
  {
    this.GL_MasterService.getGL_Childs(this.MasterAccCR, this.isBranchId)
      .subscribe(response => {
        if (response) {
            this.StudentAccounts = response;
        }
    },
    error => console.log("error --> " + error))

  }
  //AccountChanged(event,gL_ChildDesc,gL_ChildCode)
  //{
  //  console.log(event.isUserInput);
  //  if (event.isUserInput === true) {
  //    console.log(gL_ChildDesc);
  //    //console.log(this.StudentAccounts);
  //    this.selectedAccountName = gL_ChildDesc;
  //    this.prntselectedAccountName = gL_ChildDesc;
  //    this.getPendingInvoices(gL_ChildCode);
  //    this.GL_MasterService.getStudentDetails(gL_ChildCode).subscribe(
  //      result => {
  //        if (result) {
  //          this.studentDetails = result.json();
  //          console.log(this.studentDetails);
  //        }
  //      }
  //    );
  //  }
  //}
  DebitAccountChanged(event,gL_ChildCode,gL_ChildDesc)
  {
    console.log(event.isUserInput);
    if (event.isUserInput === true) {
      this.prntSelectedBankAccount = gL_ChildDesc;
      this.prntSelectedBankNumber = gL_ChildCode;
    }
  }

  blur(){
    console.log("blur");
    
  }
  getAccountMaps()
  {
    this.AccountMapService.getAccountMapping('student-invoice-clear')
      .subscribe(response => {
        if (response){
          this.ArrAccountMaps = response;
          this.setMaps();
        }
      },
      error => console.log("error --> " + error))
  }

setMaps() {
  
  this.txn_CR_Inc.GL_Code = this.ArrAccountMaps.find( (o:any) => o.component === 'student-invoice-clear' &&  o.drcr === 'C' && o.trnCode === 'ACT' ).childAcc;
  this.txn_DR_Rec.GL_Code = this.ArrAccountMaps.find( (o:any) => o.component === 'student-invoice-clear' &&  o.drcr === 'D' && o.trnCode === 'ACT' ).childAcc;
  this.MasterAccDR = this.ArrAccountMaps.find( (o:any) => o.component === 'student-invoice-clear' &&  o.drcr === 'D'  && o.trnCode === 'AAT' ).masterAcc;
  this.MasterAccCR = this.ArrAccountMaps.find( (o:any) => o.component === 'student-invoice-clear' &&  o.drcr === 'C'  && o.trnCode === 'AAT' ).masterAcc;

  console.log(concat('txn_CR_Inc' , this.txn_CR_Inc.GL_Code ));
  console.log(concat('MasterAccDR' , this.MasterAccDR));
  console.log(concat('MasterAccCR' , this.MasterAccCR));
}
  submit(a: string) {
    if (a == 'submit') {
      // submit the invoice
      var valDate = new Date(this.datepipe.transform(this.txn_DR.value_date, 'yyyy-MM-dd'));
      this.txn_DR.value_date = valDate;
      var trnDate = new Date(this.datepipe.transform(this.txn_DR.trn_date, 'yyyy-MM-dd'));
      this.txn_DR.trn_date = trnDate;
      this.txn_DR.userId = this.userId;

      this.txn_CR.trn_amount = this.txn_DR.trn_amount;
      this.txn_CR.value_date = this.txn_DR.value_date;
      this.txn_CR.trn_date = this.txn_DR.trn_date;
      this.txn_CR.remarks = this.txn_DR.remarks;
      this.txn_CR.external_ref_no = this.txn_DR.external_ref_no;
      this.txn_CR.userId = this.userId;

      this.txn_DR_Rec.trn_amount = this.txn_DR.trn_amount;
      this.txn_DR_Rec.value_date = this.txn_DR.value_date;
      this.txn_DR_Rec.trn_date = this.txn_DR.trn_date;
      this.txn_DR_Rec.remarks = this.txn_DR.remarks;
      this.txn_DR_Rec.external_ref_no = this.txn_DR.external_ref_no;
      this.txn_DR_Rec.userId = this.userId;

      this.txn_CR_Inc.trn_amount = this.txn_DR.trn_amount;
      this.txn_CR_Inc.value_date = this.txn_DR.value_date;
      this.txn_CR_Inc.trn_date = this.txn_DR.trn_date;
      this.txn_CR_Inc.remarks = this.txn_DR.remarks;
      this.txn_CR_Inc.external_ref_no = this.txn_DR.external_ref_no;
      this.txn_CR_Inc.userId = this.userId;


      this.txns = [this.txn_DR, this.txn_CR, this.txn_DR_Rec, this.txn_CR_Inc];

      console.log(this.txn_DR_Rec.GL_Code);
      //this.Txn_DE_Service.ClearInvoice_Invoice(this.txns, this.inv_number, this.prntSelectedBankAccount, this.prntSelectedBankNumber)
      this.Txn_DE_Service.ClearInvoice_Invoice(this.txns, this.inv_number)
        .subscribe(response => {
          if (response) {
            this.txn_result = response.json();
            this.arr_results['result'] = this.txn_result.find((o: any) => o.key === 'result').value;
            this.arr_results['trn_ref_no'] = this.txn_result.find((o: any) => o.key === 'trn_ref_no').value;

            if (this.arr_results['result'] == 'success') {
              this.txn_DR.trn_ref_no = this.arr_results['trn_ref_no'];
              console.log('transaction succeed. trn_ref_no --> ' + this.txn_DR.trn_ref_no);
              this.resetTrns();
              this.openSnackBar(this.txn_DR.trn_ref_no, 'چاپ');
            }
            console.log('transaction succeed. trn_ref_no 22 --> ' + this.txn_DR.trn_ref_no);
            this.getInvoice(this.txn_DR.trn_ref_no);
          }
        },
          error => {
            console.log(error);
            this.openSnackBar(null, 'خطا در ثبت');
          }
        );
    }
  }

  trnDateChanged(type: string, event: MatDatepickerInputEvent<Date>) {
    //console.log(`${type}: ${event.value}` );
    this.pdate = moment(event.value).format('jYYYY-jMM-jDD');
    this.txn_DR.value_date = moment(event.value).toDate();
    //console.log(this.txn_DR.value_date );
  }
  openSnackBar(message: string, action: string) {

    let snackBarRef = this.snackBar.open(message, action, {
      duration: 10000,
    });
    snackBarRef.dismissWithAction = function () {
      //------------------------------------------
      console.log("lkjlkj---oooo: " + this.invoiceList);

      //-------------------------------------------
      console.log('inside snack bar')
      snackBarRef.dismiss();
      var content = $("#print-section").prop('outerHTML');
      var printWindow = window.open('', '', '');
      printWindow.document.write('<html><head><title>Print</title>');
      var _link = $('link');
      var _style = $('style');
      var strstyle = '';
      var _script = $('script');
      for (var k = 0; k < _link.length; k++)
        printWindow.document.write(_link[k].outerHTML);
      for (var i = 0; i < _style.length; i++)
        printWindow.document.write(_style[i].outerHTML);
      for (var j = 0; j < _script.length; j++)
        printWindow.document.write(_script[j].outerHTML);
      printWindow.document.write('</head><body  style="-webkit-print-color-adjust: exact;     margin-top: 1px;"  >');
      printWindow.document.write(content);
      printWindow.document.write('<script> $(".AES").css("display", "block");</script> </body ></html>');
      printWindow.document.close();
      //setTimeout(() => { printWindow.print(); }, 4000);
    }

  }
  

 
resetTrns(){

  // fill the print varaibales
  
  this.printVariables['prntbankRefNo'] = this.txn_DR.external_ref_no;
  this.printVariables['trn_amount'] = this.txn_DR.trn_amount;
  this.printVariables['trn_date'] = this.pdate;
  this.printVariables['trn_desc'] = this.txn_DR.remarks;

  // reset transaction values.
  this.inv_number = null;

  this.txn_DR.trn_amount = null;
  this.txn_DR.value_date = new Date();
  this.txn_DR.remarks = '';
  this.txn_DR.GL_Code = '';
  this.txn_DR.external_ref_no = '';

  this.txn_CR.trn_amount = null;
  this.txn_CR.value_date = new Date();
  this.txn_CR.GL_Code = '';
  this.txn_CR.remarks = '';

  this.selectedAccountName = '';
}
getLabels(){
  this.UtilityService.getLabels('student-invoice-clear',this.global.lang)
    .subscribe(response => {
        if(response){
            this.ArrLabels = response;
            this.setLabels();
        }
    },
    error => console.log(error))
  }


setLabels(){
  //title
  this.labels['student-invoice-clear-Title'] = this.ArrLabels.find( (o:any) => o.key === 'student-invoice-clear-Title').value;

  // labels
  this.labels['StudentAccount'] = this.ArrLabels.find( (o:any) => o.key === 'StudentAccount').value;
  this.labels['StudentInvoice'] = this.ArrLabels.find( (o:any) => o.key === 'StudentInvoice').value;
  this.labels['billDate'] = this.ArrLabels.find( (o:any) => o.key === 'billDate').value;
  this.labels['debitAccount'] = this.ArrLabels.find( (o:any) => o.key === 'debitAccount').value;
  this.labels['StudentInvoice'] = this.ArrLabels.find( (o:any) => o.key === 'StudentInvoice').value;
  this.labels['billRemarks'] = this.ArrLabels.find( (o:any) => o.key === 'billRemarks').value;
  this.labels['BankRefNO'] = this.ArrLabels.find( (o:any) => o.key === 'BankRefNO').value;

  // Alerts
  this.labels['StudentAccountMandatory'] = this.ArrLabels.find( (o:any) => o.key === 'StudentAccountMandatory').value;
  this.labels['InvoiceMandatory'] = this.ArrLabels.find( (o:any) => o.key === 'InvoiceMandatory').value;
  this.labels['DebitAccountMandatory'] = this.ArrLabels.find( (o:any) => o.key === 'DebitAccountMandatory').value;
  this.labels['BankRefNoAlert'] = this.ArrLabels.find( (o:any) => o.key === 'BankRefNoAlert').value;
  
  // shared labels.
  this.labels['RecordStat'] = this.ArrLabels.find( (o:any) => o.key === 'RecordStat').value;
  this.labels['AuthStat'] = this.ArrLabels.find( (o:any) => o.key === 'AuthStat').value;
  this.labels['CreateDate'] = this.ArrLabels.find( (o:any) => o.key === 'CreateDate').value;
  this.labels['CheckerID'] = this.ArrLabels.find( (o:any) => o.key === 'CheckerID').value;
  this.labels['MakerID'] = this.ArrLabels.find( (o:any) => o.key === 'MakerID').value;

}

}



// WEBPACK FOOTER //
// ./src/app/components/TRNs/student-recieve-inv/student-recieve-inv.component.ts